import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=975abe7a&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"
import style0 from "./FileItem.vue?vue&type=style&index=0&id=975abe7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975abe7a",
  null
  
)

export default component.exports